var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWorkOnTrack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_Work_on_Track",
    "data-name": "icon Work on Track",
    transform: "translate(-85 -1494)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1835",
    "data-name": "Rectangle 1835",
    className: "cls-1",
    width: 24,
    height: 24,
    transform: "translate(85 1494)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_Train_99121_1_",
    "data-name": "noun_Train_99121 (1)",
    transform: "translate(69 1491)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2336",
    "data-name": "Path 2336",
    d: "M34.492,25.668l-.742-1.585H34.4l-.455-.987h-.67l-.622-1.332h.765l-.455-.987h-.789L31.645,19.7l2.536-1.562v-7.51l-.909-1.4.048-2.274S33.415,5,27.961,5,22.6,6.952,22.6,6.952l.048,2.274-.909,1.4v7.487l2.416,1.493-.55,1.171H22.555l-.455.987h1.029L22.507,23.1H21.455L21,24.084h1.029l-.742,1.585h1.148l.742-1.562h9.449l.742,1.585h1.124Zm-1.866-8.451a.694.694,0,1,1-.694-.666A.653.653,0,0,1,32.626,17.217ZM28.775,6.148s2.344.253,3.158,1.033V9.2l-3.158-.712Zm-.813,3.9a.919.919,0,1,1-.957.919A.941.941,0,0,1,27.961,10.052ZM23.823,7.2c.813-.781,3.158-1.033,3.158-1.033V8.537l-3.158.712Zm0,10.013a.694.694,0,1,1,.694.666A.681.681,0,0,1,23.823,17.217ZM25.115,20h5.55l.383.781H24.732Zm1.053,3.1H23.631l.622-1.332h7.224L32.1,23.1Z",
    transform: "translate(0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWorkOnTrack);
export default __webpack_public_path__ + "static/media/icon-work-on-track.2cd20f640664774534709bd711023442.svg";
export { ForwardRef as ReactComponent };